import type { Activity } from '~/types/tShared';
import { Institution } from '@tempus/trials-types';
import { AxiosResponse } from 'axios';

import axios from '../axios';
import { TRIALS_API_ROOT } from '../constants';
import { CreateNote, UpdateTimePatient } from '../types/portal';

export const patientsLegacyApi = {
  createNote: async (patientLinkageId: string, body: CreateNote): Promise<Activity> => {
    return axios.post(`${TRIALS_API_ROOT}/v1/patients/${patientLinkageId}/note`, body).then(({ data }) => data);
  },
  updateTimePatient: async (patientLinkageId: string, institutionId: string, body: UpdateTimePatient) => {
    return axios.post(`${TRIALS_API_ROOT}/v1/patients/timePatient/${patientLinkageId}/${institutionId}`, body);
  },
  getTimeInstitutions: async (
    patientLinkageId: string,
  ): Promise<AxiosResponse<Pick<Institution, 'id' | 'shortName' | 'name'>[]>> => {
    return axios.get(`${TRIALS_API_ROOT}/v1/patients/linkage-id/${patientLinkageId}/time-institutions`);
  },
};
